import { useState } from 'react';
import { Pressable, ScrollView, View } from 'react-native';
import { style } from './Dropdown.style';
import TextLato from '../text/text-lato/TextLato';
import { Icon } from '../icon/Icon';
import { ICON_NAMES } from '../icon/icon.helper';
import { brand } from 'src/theme/colors';

export const Dropdown = ({
  options,
  onPressOption,
  selectedOption,
  onlyIcon,
  iconName,
}: {
  options: string[];
  onPressOption: (option: string) => void;
  selectedOption?: string;
  onlyIcon?: boolean;
  iconName?: ICON_NAMES;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return onlyIcon ? (
    <View>
      <Pressable onPress={() => setIsOpen(!isOpen)}>
        <View style={[style.icon, isOpen && { transform: [{ rotate: '180deg' }] }]}>
          <Icon name={iconName ?? ICON_NAMES.ArrowBottom} color={brand.main.water} />
        </View>
      </Pressable>
      {isOpen && (
        <ScrollView style={style.optionsOnlyIcon}>
          {options.map((option, index) => {
            return (
              <Pressable
                style={style.optionOnlyIcon}
                onPress={() => {
                  onPressOption(option);
                  setIsOpen(false);
                }}
                key={'dropdown-' + index}
              >
                <TextLato style={style.text}>{option}</TextLato>
              </Pressable>
            );
          })}
        </ScrollView>
      )}
    </View>
  ) : (
    <View style={style.wraper}>
      <Pressable style={style.header} onPress={() => setIsOpen(!isOpen)}>
        <TextLato style={style.text} numberOfLines={1}>
          {selectedOption ?? options[0]}
        </TextLato>
        <View style={[style.icon, isOpen && { transform: [{ rotate: '180deg' }] }]}>
          <Icon name={ICON_NAMES.ArrowBottom} color={brand.main.water} />
        </View>
      </Pressable>
      {isOpen && (
        <View style={style.options}>
          {options.map((option, index) => {
            return (
              <Pressable
                style={style.option}
                onPress={() => {
                  onPressOption(option);
                  setIsOpen(false);
                }}
                key={'dropdown-' + index}
              >
                <TextLato style={style.text}>{option}</TextLato>
              </Pressable>
            );
          })}
        </View>
      )}
    </View>
  );
};
